import React from 'react';
import './ITSoftware.css';

function RetailEcommerce() {
  return (
    <div className="service-page">
      {/* Hero Section */}
      <section
        className="hero-image-section"
        style={{ backgroundImage: "url('/images/retail_hero.png')" }}
      >
        <div className="hero-text-container">
          <h1>Retail & E-commerce</h1>
          <p>Tax, tech and trade expertise to scale physical and digital retail businesses</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="service-content">
        <div className="content-left">
          <h2>Your growth engine behind every cart and click.</h2>
          <p>We help retail and e-commerce companies with GST setup, POS compliance, and e-invoicing automation.</p>
          <p>From vendor agreements to warehousing and logistics optimization, we guide you across the retail value chain.</p>
          <p>Our experts handle taxation of discount schemes, inventory valuation, and channel-wise reporting.</p>
          <p>Whether you're on Shopify, Amazon, or running multi-store chains, we ensure financial and regulatory clarity for scale.</p>
        </div>
        <div className="content-right">
          <img src="/images/retail.jpg" alt="Retail & E-commerce" />
        </div>
      </section>
    </div>
  );
}

export default RetailEcommerce;
